import React from 'react';
import { Alert, Box, Card, Set } from 'bumbag';
import { Form, Formik } from 'formik';
import _get from 'lodash/get';
import Loads from 'react-loads';

import { ErrorMessage } from '@medipass/react-core';
import { WithLoadingIndicator } from '@medipass/react-core';
import sdk from '@medipass/web-sdk';

import HealthFundCardFields from './HealthFundCardFields';

import SubmitCancelButtons from '../../SubmitCancelButtons';

type Props = {
  initialValues?: Record<string, any> | null | undefined;
  isMobileTitle?: boolean;
  isSelfCheckoutSession?: boolean;
  isSubmitButtonInsideSection?: boolean;
  onClickCancel?: ((...args: Array<any>) => any) | null | undefined;
  onSubmit: (...args: Array<any>) => any;
  submitButtonRenderer?: ((...args: Array<any>) => any) | null | undefined;
  title: string;
};
const INITIAL_VALUES = {
  cardRank: '',
  expiryDate: '',
  healthFund: '',
  membershipNumber: '',
};
export default class HealthFundAccountForm extends React.Component<Props> {
  static defaultProps = {
    isSelfCheckoutSession: false,
    isSubmitButtonInsideSection: false,
    isMobileTitle: true,
    initialValues: INITIAL_VALUES,
    onClickCancel: null,
    submitButtonRenderer: null,
  };
  getMedicareHealthFund = async ({ setFieldValue }: { setFieldValue: (...args: Array<any>) => any }) => {
    const { isSelfCheckoutSession } = this.props;
    const healthFund = await sdk.healthfunds.getMedicareHealthFund(
      isSelfCheckoutSession
        ? {
            requestConfig: {
              tokenType: 'session',
            },
          }
        : {},
    );
    setFieldValue('healthFundId', _get(healthFund, '_id'));
    return healthFund;
  };
  render = () => {
    const {
      initialValues,
      isMobileTitle,
      isSubmitButtonInsideSection,
      onClickCancel,
      onSubmit,
      submitButtonRenderer,
      title,
    } = this.props;
    return (
      <Loads load={onSubmit}>
        {/* @ts-expect-error TS(7031): Binding element 'error' implicitly has an 'any' ty... Remove this comment to see the full error message */}
        {({ error, load: handleSubmitMemberDetails, isLoading, isError }) => (
          <Box>
            <Formik initialValues={{ ...INITIAL_VALUES, ...initialValues }} onSubmit={handleSubmitMemberDetails}>
              {({ setFieldValue, values }) => {
                return (
                  <Form noValidate>
                    <Set display="block" orientation="vertical" spacing="major-2">
                      <Card>
                        {isMobileTitle ? <p className="font-semibold">{title}</p> : <h2>{title}</h2>}
                        <Loads
                          contextKey="medicareHealthFund"
                          loadOnMount
                          load={() =>
                            this.getMedicareHealthFund({
                              setFieldValue,
                            })
                          }
                        >
                          {/* @ts-expect-error TS(7031): Binding element 'medicareHealthFund' implicitly ha... Remove this comment to see the full error message */}
                          {({ response: medicareHealthFund, isLoading, isSuccess }) => (
                            <WithLoadingIndicator isActive={isLoading}>
                              {isSuccess && (
                                <HealthFundCardFields
                                  cardholder={`${_get(sdk, 'member.firstName')} ${_get(sdk, 'member.lastName')}`}
                                  cardRank={values.cardRank}
                                  expiryDate={values.expiryDate}
                                  membershipNumber={values.membershipNumber}
                                  healthFundId={medicareHealthFund._id}
                                />
                              )}
                            </WithLoadingIndicator>
                          )}
                        </Loads>
                        {isError && (
                          <Alert variant="tint" hasIcon marginTop="major-2" type="danger">
                            <ErrorMessage description="Unable to submit medicare details" err={error} />
                          </Alert>
                        )}
                        {isSubmitButtonInsideSection && (
                          <Box marginTop="major-3">
                            {submitButtonRenderer ? (
                              submitButtonRenderer({
                                isDisabled: !values.healthFund,
                                isLoading,
                              })
                            ) : (
                              <SubmitCancelButtons
                                cancelText="CANCEL"
                                submitProps={{
                                  // @ts-expect-error TS(2551): Property 'healthFundId' does not exist on type '{ ... Remove this comment to see the full error message
                                  disabled: !values.healthFundId,
                                }}
                                isLoading={isLoading}
                                onClickCancel={onClickCancel}
                                submitText="SAVE"
                              />
                            )}
                          </Box>
                        )}
                      </Card>
                      {!isSubmitButtonInsideSection && (
                        <Box>
                          {submitButtonRenderer ? (
                            submitButtonRenderer({
                              isDisabled: !values.healthFund,
                              isLoading,
                            })
                          ) : (
                            <SubmitCancelButtons
                              cancelText="CANCEL"
                              submitProps={{
                                // @ts-expect-error TS(2551): Property 'healthFundId' does not exist on type '{ ... Remove this comment to see the full error message
                                disabled: !values.healthFundId,
                              }}
                              isLoading={isLoading}
                              onClickCancel={onClickCancel}
                              submitText="SAVE"
                            />
                          )}
                        </Box>
                      )}
                    </Set>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        )}
      </Loads>
    );
  };
}
